import React from 'react';

import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import MainComponent from '../../commons/main/mainComponent';

import { checkCookie } from '../../../utils/cookies';
import config from '../../../config';

import './loginView.css';

const LoginView = ({
    success,
    message,
    handleLogin,
    handleInputChange,
}) => {
    const { t } = useTranslation();

    return (
        <div className="loginview_container">
            <MainComponent>
                <h3 className="text-center">{t('common.serviceName')}</h3>
                {checkCookie() !== null ? <Redirect to="/admin" /> : null}
                {message ? (
                    <Alert variant={!success ? 'danger' : 'success'}>
                        {t(message.key, message.params)}
                    </Alert>
                ) : null}
                <Form onSubmit={handleLogin} className="login-form">
                    <Form.Group>
                        <Form.Label>{t('login.email')}</Form.Label>
                        <Form.Control
                            type="text"
                            name="email"
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>{t('login.password')}</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            onChange={handleInputChange}
                        />
                    </Form.Group>

                    <Button className="button-main" type="submit" variant="success">
                        <FontAwesomeIcon icon="sign-in-alt" />{' '}
                        {t('login.submit')}
                    </Button>
                </Form>
                <hr />
                <div className="btm-links">
                    <div>
                        {config.paymentOptions ? (
                            <p>
                                <Link to="join">{t('login.joinLink')}</Link>
                            </p>
                        ) : null}
                        <p>
                            <Link to="forgot">{t('login.forgotPassword')}</Link>
                        </p>
                        <p>
                            <a href="https://www.digit.fi/viralliset/tietosuojaseloste/" rel="noopener noreferrer" target="_blank">
                                {t('login.privacyStatement')}
                            </a>
                        </p>
                    </div>
                    <div>
                        <p>
                            <a href="https://www.digit.fi/" rel="noopener noreferrer" target="_blank">
                                {t('login.digitWebsite')}
                            </a>
                        </p>
                        <p>
                            <a href="mailto:digit@utu.fi" rel="noopener noreferrer" target="_blank">
                                {t('login.boardContact')}
                            </a>
                        </p>
                    </div>
                </div>
            </MainComponent>
        </div>
    );
};

export default LoginView;
